import { Component, OnDestroy } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { KnowledgeService } from 'src/app/services/knowledge/knowledge.service'
import { AppState } from 'src/app/store/state/app.state'
import { KnowledgeState } from 'src/app/store/state/knowledge.state'

@Component({
  selector: 'app-view-knowledge-article',
  templateUrl: './view-knowledge-article.component.html',
  styleUrls: ['./view-knowledge-article.component.scss']
})
export class ViewKnowledgeArticleComponent implements OnDestroy {
  userKnowledgeDetails$: Subscription
  previousUrl: string
  sanitizedContent: SafeHtml
  knowledgeArticle: KnowledgeState

  constructor(
    private appState: Store<AppState>,
    private router: ActivatedRoute,
    private knowledgeService: KnowledgeService,
    private route: Router,
    private readonly domSanitizer: DomSanitizer
  ) {
    this.router.params.subscribe((params) => {
      const id = params['id']
      this.dispatchFetchKnowledgeDetailsAction(id)
    })
    const navigation = this.route.getCurrentNavigation()
    if (navigation && navigation.previousNavigation) {
      this.previousUrl = navigation.previousNavigation.finalUrl.toString()
    }
    this.userKnowledgeDetails$ = this.appState.select('knowledge').subscribe((data) => {
      if (data) {
        this.knowledgeArticle = data
        this.sanitizedContent = this.domSanitizer.bypassSecurityTrustHtml(data?.details?.contents)
      }
    })
  }

  back() {
    if (this.previousUrl) {
      this.route.navigate([this.previousUrl])
    } else {
      const viewAllPage = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.LIST}`
      this.route.navigate([viewAllPage])
    }
  }

  dispatchFetchKnowledgeDetailsAction(id: string) {
    this.knowledgeService.dispatchViewKnowledgeAction(id)
  }

  ngOnDestroy() {
    this?.userKnowledgeDetails$?.unsubscribe()
  }
}
